// extracted by mini-css-extract-plugin
export default {"commonDeleteExternalProduct":"styles_common-delete-external-product__EuIt2"};